import {
  BulkJobStatusEnum,
  isBulkJobFinished,
  getBulkJobStatusColor,
  BULK_JOB_STATUS_COLORS
} from './bulkJobConstants'

export type { BulkJobStatusEnum }
export { isBulkJobFinished, getBulkJobStatusColor, BULK_JOB_STATUS_COLORS }

// Storage key for persisting lock job ID across sessions
export const LOCK_JOB_STORAGE_KEY = 'bulkLockJobId'

// Custom event name for job start notifications
export const LOCK_JOB_STARTED_EVENT = 'bulkLockJobStarted'

// Polling interval in milliseconds for job status updates
export const POLLING_INTERVAL_MS = 1000

// Type for custom event detail
export interface BulkLockJobStartedEventDetail {
  jobId: string
}
